import "@hotwired/turbo-rails"
import "./controllers"
import { initCookieConsent } from "./cookie_consent"

// Init once on first load, Turbo handles subsequent navigations without re-init
document.addEventListener("DOMContentLoaded", initCookieConsent, { once: true })
